/**
 * The phone bottom bar's link tabs (#2487 T2-T4). "More" is not here: it opens
 * the sidebar drawer and is not a link. Paths and the `_phone` view come from
 * `lib/routes.ts`, the one place both the shell and the dispatch page read.
 */
import { PERMISSIONS, type PermissionKey } from '@/permissions';
import { PHONE_VIEW, PHONE_VIEW_PARAM, ROUTES } from '@lib/routes';

export const MOBILE_TAB = { now: 'now', jobs: 'jobs', inbox: 'inbox' } as const;
export type MobileTab = (typeof MOBILE_TAB)[keyof typeof MOBILE_TAB];

interface MobileTabDef {
  key: MobileTab;
  labelKey: string;
  href: string;
  permissions: readonly PermissionKey[];
  isActive(pathname: string, search: string): boolean;
}

const isPhoneInbox = (search: string) =>
  new URLSearchParams(search).get(PHONE_VIEW_PARAM) === PHONE_VIEW.inbox;

const isUnder = (pathname: string, root: string) =>
  pathname === root || pathname.startsWith(`${root}/`);

export const MOBILE_TABS = [
  {
    key: MOBILE_TAB.now,
    labelKey: 'mobileNav.now',
    href: ROUTES.dispatch.root,
    permissions: [PERMISSIONS.DISPATCH_READ],
    isActive: (pathname, search) => pathname === ROUTES.dispatch.root && !isPhoneInbox(search),
  },
  {
    key: MOBILE_TAB.jobs,
    labelKey: 'mobileNav.jobs',
    href: ROUTES.dispatch.jobs,
    permissions: [PERMISSIONS.DISPATCH_READ],
    isActive: (pathname) => isUnder(pathname, ROUTES.dispatch.jobs),
  },
  {
    key: MOBILE_TAB.inbox,
    labelKey: 'mobileNav.inbox',
    href: ROUTES.dispatch.phoneInbox,
    permissions: [PERMISSIONS.DISPATCH_READ, PERMISSIONS.REVIEW_READ],
    isActive: (pathname, search) => pathname === ROUTES.dispatch.root && isPhoneInbox(search),
  },
] as const satisfies readonly MobileTabDef[];
